import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useRequestCreativeForDimension } from '@/entities/creatives';
import { useOptionalCreativeDrawerContext } from '../DataTableContext/CreativeDrawerContext';

const ImageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.25),
  height: '100%',
  aspectRatio: '1 / 1',
}));

const Image = styled('img')(() => ({
  height: '100%',
  width: '100%',
  aspectRatio: '1 / 1',
  objectFit: 'contain',
}));

interface Props {
  readonly dimension: string;
  readonly value: string;
}

export function MediaCell({ dimension, value }: Props) {
  const creative = useRequestCreativeForDimension(value, dimension);
  const url = creative?.thumbnailUrl ?? '';
  const { openCreativeDrawer } = useOptionalCreativeDrawerContext() ?? {};

  const handleOpenDetails = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (creative?.adId && openCreativeDrawer) {
      openCreativeDrawer(creative.adId);
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        cursor: creative ? 'pointer' : 'inherit',
      }}
      onClick={handleOpenDetails}
    >
      {url && (
        <ImageWrapper>
          <Image src={url} />
        </ImageWrapper>
      )}
      <Box
        title={value}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </Box>
    </Box>
  );
}
